export default "__VITE_ASSET__EICkzBtf__"